module.exports = __webpack_public_path__ + "2024523:cc8b0e4ed9b4c71b9cb2/img/Luminary-homepage-3-L-1024x576.258b81c.jpg";